import moment from "moment"

export default function(input) {
  // TODO @boris into Record
  return {
    id: input.id, // integer
    bid: input.bid, // integer
    amount: input.amount, // float
    currency: input.currency.toLowerCase(), // string
    type: input.type,
    time: moment.utc(input.time * 1000),
  }
}
